export default "__VITE_ASSET__Detqn1pq__"